import { Coach, request } from "./client";
import { registerMessages } from "./errors";

registerMessages({
  "invalid id": "Некорректный запрос",
  "month must be YYYY-MM": "Месяц указан неверно",
  "paid_amount cannot be negative": "Сумма выплаты не может быть отрицательной",
  "failed to list payments": "Не удалось загрузить выплаты",
  "failed to upsert payment": "Не удалось сохранить выплату",
  "failed to list salary history": "Не удалось загрузить историю ставок",
  "from and to query params are required": "Не указан период",
  "invalid from date": "Начало периода указано неверно",
  "invalid to date": "Конец периода указан неверно",
  "failed to list trainings": "Не удалось загрузить тренировки",
});

export interface SalaryHistoryEntry {
  id: string;
  coach_id: number;
  salary: number;
  effective_from: string;
  created_at: string;
}

export interface EarningsSession {
  training_id: string;
  date: string;
  title: string;
  salary: number;
}

export interface Earnings {
  count: number;
  total: number;
  sessions: EarningsSession[] | null;
}

export interface CoachPayment {
  id: string;
  coach_id: number;
  month_year: string;
  paid_amount: number;
  updated_at: string;
}

export const coachSalaryApi = {
  // Only the rate is sent: the server keeps every other field as it is and
  // writes a salary history row itself when the value changes.
  setRate: (coachID: number, salary: number) =>
    request<Coach>(`/api/coaches/${coachID}`, {
      method: "PUT",
      body: JSON.stringify({ salary_per_training: salary }),
    }),

  listSalaryHistory: (coachID: number) =>
    request<SalaryHistoryEntry[] | null>(`/api/coaches/${coachID}/salary-history`),

  getEarnings: (coachID: number, from: string, to: string) =>
    request<Earnings>(`/api/coaches/${coachID}/earnings?${new URLSearchParams({ from, to })}`),

  listPayments: (coachID: number) =>
    request<CoachPayment[] | null>(`/api/coaches/${coachID}/payments`),

  // The amount replaces what was recorded for the month, it is not added to it.
  setPaid: (coachID: number, month: string, paidAmount: number) =>
    request<CoachPayment>(`/api/coaches/${coachID}/payments/${month}`, {
      method: "PUT",
      body: JSON.stringify({ paid_amount: paidAmount }),
    }),
};
